import GroupMember from "features/groups/components/GroupMember";
import Trans from "features/translation/components/Trans";
import PropTypes from "prop-types";
import Empty from "features/view/components/Empty/Empty";
import useData from "hooks/useData";
import { useEffect, useState } from "react";
import Loader from "components/ui/Loader/Loader";
import Pager from "components/ui/Pager/Pager";

const GroupMembers = ({ groupId, groupIsPrivate, currentUserIsGroupAdmin, onMemberCountUpdated }) => {
  const { getData } = useData();
  const [ loading, setLoading ] = useState(true);
  const [ members, setMembers ] = useState([]);
  const [ refreshToken, setRefreshToken ] = useState();
  const [ page, setPage ] = useState(1);

  useEffect(
    () => {
      const loadMembers = async () => {
        setLoading(true);
        const { data } = await getData(`rest/group_members/${ groupId }`, `page=${ page + 1 }`, true, false);
        setMembers(data);
        if (data) {
          onMemberCountUpdated(data.active_members);
        }
        setLoading(false);
      }

      loadMembers();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ groupId, page, refreshToken ]);

  const onUpdated = async () => {
    setRefreshToken(Math.random());
  }

  if (loading) {
    return <Loader containerVariant={ 'center' }/>;
  }

  if (!members?.results?.length) {
    return (
      <Empty>
        <Trans text={ `Er zijn geen groepsleden binnen deze groep`} />
      </Empty>
    )
  }

  const handlePageChange = (page) => {
    setPage(page);
  }

  return (
    <>
      {
        members.results.map(member => <GroupMember key={ member.id }
                                                   id={ parseInt(member.id) }
                                                   profile={ member.profile }
                                                   status={ member.status }
                                                   isAdmin={ member.is_admin }
                                                   showAccessControls={ currentUserIsGroupAdmin && groupIsPrivate }
                                                   onUpdated={ onUpdated } />)
      }
      <Pager currentPage={ page } totalPages={ members.pager.total_pages } onChange={ handlePageChange } />
    </>
  );
}

GroupMembers.propTypes = {
  groupId: PropTypes.number.isRequired,
  groupIsPrivate: PropTypes.bool.isRequired,
  currentUserIsGroupAdmin: PropTypes.bool.isRequired,
  onMemberCountUpdated: PropTypes.func.isRequired
}

export default GroupMembers;
